<template>
  <div class="cart-widget__item__remove">
    <div
        class="col-12 col-xl"
        ref="colLeft"
    >
      <div class="cart-widget__items__item__title">
        <span v-html="product.name"></span>
      </div>
      <BaseSpacer size="m"/>
      <p
          v-if="!isOrderCancel"
          class="fs-regular"
      >
        Das Produkt <i v-html="product.name"></i> aus deinem Warenkorb entfernen?
      </p>
      <p
          v-else
      >
        Das Produkt <i v-html="product.name"></i> aus deinem Warenkorb entfernen und die aktuelle Bestellung
        abbrechen?
      </p>
      <BaseSpacer size="m"/>
      <BaseGridRow>
        <BaseGridCol :s="{ xs: 12, lg: 6}">
          <BaseButton
              link-type="button"
              width="full"
              color="dark-outline"
              @click="$.emit('clear')"
          >
            Nein
          </BaseButton>
        </BaseGridCol>
        <BaseGridCol :s="{ xs: 12, lg: 6}">
          <BaseButton
              link-type="button"
              width="full"
              color="red-orange"
              @click="onApprove"
          >
            Ja
          </BaseButton>
        </BaseGridCol>
      </BaseGridRow>
    </div>
  </div>
</template>

<script lang="ts">
import BaseGridRow from '@/components/BaseGridRow.vue';
import {
  defineComponent,
  PropType,
} from 'vue';
import { useStore } from 'vuex';
import Product from '@/classes/Product';
import { formatNumber } from '@/helpers';

export default defineComponent({
  components: { BaseGridRow },
  props: {
    itemKey: {
      type: String,
      required: true,
    },
    product: {
      type: Object as PropType<Product>,
      required: true,
    },
    isOrderCancel: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },

  emits: ['clear', 'approved'],

  setup(props, context) {
    const store = useStore();

    const onApprove = () => {
      store.dispatch('cart/remove', {
        key: props.itemKey,
        product: props.product,
      }).then(() => {
        context.emit('approved');
      });
    };

    return {
      formatNumber,
      onApprove,
    };
  },
});
</script>

<style lang="scss">
@import "src/scss/component-helpers";

.cart-widget__item__remove {
  &__title {
    display: flex;
    flex-wrap: wrap;
    @include responsive-size(16);
    color: #727171;

    img {
      display: block;
      height: 2.375em;
      width: auto;
    }

    align-items: center;

    > span {
      &:nth-child(1), &:nth-child(2) {
        flex: 1 0 0%;
        width: 100%;
        align-self: flex-end;
        padding-left: .5625em;
      }

      &:nth-child(2) {
        align-self: center;
      }
    }
  }
}
</style>
